<template>
	<fieldset class="group-container">
		<BuyersOrderRow
			class="subtotal-container"
			:hideExtraColumns
		>
			<template #left-icon>
				<button
					class="button-span ignore-all-locks"
					@click="toggleOpen()"
				>
					<i :class="['far', isOpen ? 'fa-minus-square' : 'fa-plus-square']" />
				</button>
			</template>

			<template #info>
				<span>{{ name }}</span>

				<slot
					v-if="isOpen"
					name="group-action"
				>
				</slot>
			</template>

			<template #right-icon>
				<slot name="right-icon"></slot>
			</template>

			<template #column-1>
				<slot name="column-1"></slot>
			</template>

			<template #column-2>
				<slot name="column-2"></slot>
			</template>

			<template #column-3>
				<slot name="column-3"></slot>
			</template>
		</BuyersOrderRow>

		<template v-if="isOpen">
			<div class="group-children-container">
				<slot name="children"></slot>
			</div>
		</template>
	</fieldset>
</template>

<script setup lang="ts">
	import BuyersOrderRow from './BuyersOrderRow.vue';
	import { ref } from 'vue';

	interface IBuyersOrderGroupProps {
		isOpenByDefault?: boolean;
		hideExtraColumns?: boolean;
		name: string;
	}

	const { isOpenByDefault = false, hideExtraColumns = false, name } = defineProps<IBuyersOrderGroupProps>();

	const isOpen = ref(isOpenByDefault);

	function toggleOpen() {
		isOpen.value = !isOpen.value;
	}
</script>

<style scoped></style>
